module.exports = __webpack_public_path__ + "media/vidCartoon-Fruits.f11e3b04.mp4";